import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from "react";
import { Clock } from "@phosphor-icons/react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Drawer, DrawerContent, DrawerHeader, DrawerTitle, DrawerTrigger } from "@/components/ui/drawer";
interface TimePickerProps {
  time: string;
  onChange: (time: string) => void;
  className?: string;
}
export function formatTimeDisplay(time: string) {
  if (!time) return "";
  const [hours, minutes] = time.split(":");
  const hour = parseInt(hours);
  const ampm = hour >= 12 ? "PM" : "AM";
  const hour12 = hour % 12 || 12;
  return `${hour12}:${minutes} ${ampm}`;
}
export function TimePicker(t0) {
  const $ = _c(26);
  const {
    time,
    onChange,
    className
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [period, setPeriod] = useState("AM");
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const checkIfMobile = () => setIsMobile(window.innerWidth < 768);
      checkIfMobile();
      window.addEventListener("resize", checkIfMobile);
      return () => window.removeEventListener("resize", checkIfMobile);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[2] !== time) {
    t3 = () => {
      if (time) {
        const hour = parseInt(time.split(":")[0]);
        setPeriod(hour >= 12 ? "PM" : "AM");
      }
    };
    t4 = [time];
    $[2] = time;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  useEffect(t3, t4);
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = Array.from({
      length: 12
    }, _temp);
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const hours = t5;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = Array.from({
      length: 12
    }, _temp2);
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const minutes = t6;
  let t7;
  if ($[7] !== onChange || $[8] !== period || $[9] !== time) {
    t7 = value => {
      let hour_0 = parseInt(value);
      if (period === "PM" && hour_0 !== 12) {
        hour_0 = hour_0 + 12;
      }
      if (period === "AM" && hour_0 === 12) {
        hour_0 = 0;
      }
      const mins = time ? time.split(":")[1] : "00";
      onChange(`${hour_0.toString().padStart(2, "0")}:${mins}`);
    };
    $[7] = onChange;
    $[8] = period;
    $[9] = time;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const handleHourChange = t7;
  let t8;
  if ($[11] !== onChange || $[12] !== time) {
    t8 = newPeriod => {
      setPeriod(newPeriod);
      if (!time) {
        return;
      }
      const [hours_0, minutes_0] = time.split(":");
      let hour_1 = parseInt(hours_0);
      if (newPeriod === "PM" && hour_1 < 12) {
        hour_1 = hour_1 + 12;
      }
      if (newPeriod === "AM" && hour_1 >= 12) {
        hour_1 = hour_1 - 12;
      }
      onChange(`${hour_1.toString().padStart(2, "0")}:${minutes_0}`);
    };
    $[11] = onChange;
    $[12] = time;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const handlePeriodChange = t8;
  let t9;
  if ($[14] !== handleHourChange || $[15] !== handlePeriodChange || $[16] !== onChange || $[17] !== period || $[18] !== time) {
    t9 = t10 => {
      const {
        inDrawer: t11
      } = t10;
      const inDrawer = t11 === undefined ? false : t11;
      return <div className={cn("flex flex-col", inDrawer ? "gap-6 px-4" : "gap-3")}><div className={cn("grid grid-cols-3 gap-2", inDrawer ? "gap-3" : "gap-2")}><Select value={time ? (parseInt(time.split(":")[0]) % 12 || 12).toString() : ""} onValueChange={handleHourChange}><SelectTrigger className={cn("w-full px-3 text-sm border rounded-lg bg-background hover:bg-accent focus:ring-1 focus:ring-ring", inDrawer ? "h-12" : "h-9")}><SelectValue placeholder="HH" /></SelectTrigger><SelectContent className={cn("p-0 rounded-lg", inDrawer ? "h-[280px]" : "h-[200px]")} position="popper">{hours.map(hour_2 => <SelectItem key={hour_2} value={hour_2.toString()} className={cn("cursor-pointer text-sm justify-center", inDrawer ? "py-2.5" : "py-1.5")}>{hour_2.toString().padStart(2, "0")}</SelectItem>)}</SelectContent></Select><Select value={time ? time.split(":")[1] : ""} onValueChange={value_0 => {
            const hrs = time ? time.split(":")[0] : "00";
            onChange(`${hrs}:${value_0}`);
          }}><SelectTrigger className={cn("w-full px-3 text-sm border rounded-lg bg-background hover:bg-accent focus:ring-1 focus:ring-ring", inDrawer ? "h-12" : "h-9")}><SelectValue placeholder="MM" /></SelectTrigger><SelectContent className={cn("p-0 rounded-lg", inDrawer ? "h-[280px]" : "h-[200px]")} position="popper">{minutes.map(minute => <SelectItem key={minute} value={minute.toString().padStart(2, "0")} className={cn("cursor-pointer text-sm justify-center", inDrawer ? "py-2.5" : "py-1.5")}>{minute.toString().padStart(2, "0")}</SelectItem>)}</SelectContent></Select><Select value={period} onValueChange={value_1 => handlePeriodChange(value_1)}><SelectTrigger className={cn("w-full px-3 text-sm border rounded-lg bg-background hover:bg-accent focus:ring-1 focus:ring-ring", inDrawer ? "h-12" : "h-9")}><SelectValue /></SelectTrigger><SelectContent className="p-0 rounded-lg" position="popper">{["AM", "PM"].map(p => <SelectItem key={p} value={p} className={cn("cursor-pointer text-sm justify-center", inDrawer ? "py-2.5" : "py-1.5")}>{p}</SelectItem>)}</SelectContent></Select></div><div className={cn("grid grid-cols-2 gap-2", inDrawer ? "mt-2" : "mt-1")}><Button variant="outline" size={inDrawer ? "lg" : "default"} className="w-full rounded-lg font-medium" onClick={() => {
            onChange("");
            setIsOpen(false);
          }}>Clear</Button><Button size={inDrawer ? "lg" : "default"} className="w-full rounded-lg font-medium" onClick={() => setIsOpen(false)}>Set time</Button></div></div>;
    };
    $[14] = handleHourChange;
    $[15] = handlePeriodChange;
    $[16] = onChange;
    $[17] = period;
    $[18] = time;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const TimePickerContent = t9;
  let t10;
  if ($[20] !== TimePickerContent || $[21] !== className || $[22] !== isMobile || $[23] !== isOpen || $[24] !== time) {
    t10 = <>{isMobile ? <Drawer open={isOpen} onOpenChange={setIsOpen}><DrawerTrigger asChild={true}><Button variant={time ? "secondary" : "ghost"} size="sm" className={cn("h-9 text-sm flex items-center gap-2 px-3 rounded-lg transition-colors", className)}><Clock className="w-4 h-4" weight="fill" />{time ? formatTimeDisplay(time) : "Set time"}</Button></DrawerTrigger><DrawerContent className="px-4 pb-6"><DrawerHeader className="text-center pt-6 pb-6"><DrawerTitle className="text-xl font-semibold mb-1">Choose time</DrawerTitle><p className="text-sm text-muted-foreground">{time ? formatTimeDisplay(time) : "No time selected"}</p></DrawerHeader><TimePickerContent inDrawer={true} /></DrawerContent></Drawer> : <Popover open={isOpen} onOpenChange={setIsOpen}><PopoverTrigger asChild={true}><Button variant={time ? "secondary" : "ghost"} size="sm" className={cn("h-9 text-sm flex items-center gap-2 px-3 rounded-lg transition-colors", className)}><Clock className="w-4 h-4" weight="fill" />{time ? formatTimeDisplay(time) : "Set time"}</Button></PopoverTrigger><PopoverContent className="w-[280px] p-3 rounded-xl" align="start"><TimePickerContent /></PopoverContent></Popover>}</>;
    $[20] = TimePickerContent;
    $[21] = className;
    $[22] = isMobile;
    $[23] = isOpen;
    $[24] = time;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
}
function _temp2(__0, i_0) {
  return i_0 * 5;
}
function _temp(_, i) {
  return i + 1;
}